const Ipconfig = {
  BACKEND_IP: () => {
    return 'https://server.salvationlamb.com/api/v1';
    // return 'http://209.182.233.218:4200/api/v1';
    // return 'http://localhost:4000/api/v1';
    // return 'https://dev-server.salvationlamb.com/api/v1';
  },
};
export default Ipconfig;
